export default "__VITE_ASSET__6pu5HR1___"